import {
  GAME_TITLES,
  MAP_TITLES,
  SUB_TITLES
} from "./titleArrays.js";

module.exports.getGameTitle = function(game) {
    if (game == null){return '';}
    var arr = GAME_TITLES;
    var title = arr[game];
    return title;
}

module.exports.getMapTitle = function(map) {
    if (map == null){return '';}
    var arr = MAP_TITLES;
    var title = arr[map];
    return title;
}

module.exports.getSubTitle = function(num) {
    var arr = SUB_TITLES;
    var title = arr[num.toString()];
    return title;
}



// WEBPACK FOOTER //
// ./src/app/utils/maps/titleUtil.js